"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Phone = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 6,
  viewBox: "0 0 16 6"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M0 3.83952C1.38662 1.57347 4.44687 -3.41296e-05 7.99905 5.39493e-07C11.5522 -0.00106396 14.6134 1.57329 16 3.83955L13.9571 5.86491C13.7504 6.06979 13.4528 6.01815 13.2046 5.86492L10.8208 4.38607L10.842 2.25312C9.9747 1.98698 9.0138 1.83984 8.00073 1.83894C6.98858 1.83895 6.02675 1.9869 5.15946 2.25316L5.18063 4.38611L2.79686 5.86499C2.54865 6.01823 2.25105 6.06993 2.04433 5.86499L0 3.83952Z",
  className: "fill"
}));

var _default = Phone;
exports.default = _default;